import { Loader2, SearchX } from "lucide-react";

export function Spinner() {
  return (
    <div className="flex justify-center py-16" data-testid="loading-spinner">
      <Loader2 className="animate-spin text-[#E54D2E]" size={28} />
    </div>
  );
}

export function EmptyState({ title = "Sin resultados", subtitle }) {
  return (
    <div className="flex flex-col items-center px-6 py-16 text-center" data-testid="empty-state">
      <div className="mb-3 flex h-16 w-16 items-center justify-center rounded-full bg-[#F3F0E6]">
        <SearchX className="text-[#5C5C5C]" size={26} />
      </div>
      <p className="font-display text-lg font-bold text-[#1A1A1A]">{title}</p>
      {subtitle && <p className="mt-1 text-sm text-[#5C5C5C]">{subtitle}</p>}
    </div>
  );
}
